import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const DataTableWithoutPagination = ({
  columns,
  data,
  globalFilter,
}) => {
  return (
    <DataTable
      value={data}
      className="main-table table-td"
      scrollable
      scrollHeight="calc(100vh - 270px)"
      responsiveLayout="scroll"
      globalFilter={globalFilter}
    >
      {columns?.map((col, indx) => (
        <Column
          key={indx}
          field={col?.field}
          header={col?.header}
          body={col.body}
          fitler
          filterMatchMode="contains"
          sortable
        />
      ))}
    </DataTable>
  );
};

export default DataTableWithoutPagination;
